import { useEffect, useState } from 'react';
import { Button, Divider, Input, Select, Tag, Typography } from 'antd';

const { Title } = Typography;

export const VehicleSection = ({ vehicles, radDevices, action, setAction, setManaging, setSave, radDevicesPanel }) => {
    const [selectedVehicle, setSelectedVehicle] = useState(-1)
    const [newVehicleName, setNewVehicleName] = useState('');
    const [createVehicleName, setCreateVehicleName] = useState('');
    const [selectedRadSerial, setSelectedRadSerial] = useState(null);

    const unassignedRads = (radDevices || []).filter(r => !r.vehicle_id);

    useEffect(() => {
        setSelectedVehicle(-1)
    }, [vehicles])

    useEffect(() => {
        if (selectedVehicle !== -1) {
            setNewVehicleName(vehicles[selectedVehicle].name)
        }
    }, [selectedVehicle])

    return (
        <div>
            <div className="groups vehicleGroups">
                <div className="buttons">
                    <Title className="title" level={4}>Options</Title>
                    <Button
                        className="button"
                        disabled={action}
                        onClick={() => {
                            setManaging('Vehicles')
                            setAction('renameVehicle')
                        }}
                    >
                        Rename Vehicle
                    </Button>
                    <Button
                        className="button"
                        disabled={action}
                        onClick={() => {
                            setManaging('Vehicles')
                            setAction('createVehicle')
                        }}
                    >
                        Create Vehicle
                    </Button>
                    <Button
                        className="button"
                        disabled={action}
                        onClick={() => {
                            setManaging('Vehicles')
                            setAction('assignRad')
                        }}
                    >
                        Assign RAD
                    </Button>
                    <Button
                        className="button"
                        disabled={action}
                        onClick={() => {
                            setManaging('Vehicles')
                            setAction('removeRad')
                        }}
                    >
                        Remove RAD
                    </Button>

                    {action === 'renameVehicle' && (
                        <Button
                            className='button'
                            disabled={newVehicleName === '' || newVehicleName === vehicles[selectedVehicle]?.name || selectedVehicle < 0}
                            onClick={() => {
                                setSave([vehicles[selectedVehicle].id, newVehicleName])
                            }}
                        >
                            Save
                        </Button>
                    )}

                    {action === 'removeRad' && selectedVehicle >= 0 && vehicles[selectedVehicle]?.rad_serial && (
                        <Button
                            className='button'
                            type="primary"
                            danger
                            onClick={() => {
                                setSave({
                                    vehicle_id: vehicles[selectedVehicle].id,
                                })
                            }}
                        >
                            Confirm Remove RAD
                        </Button>
                    )}

                    {action && (
                        <Button
                            className="button"
                            onClick={() => {
                                setAction('')
                                setSelectedVehicle(-1)
                                setSelectedRadSerial(null)
                                setCreateVehicleName('')
                            }}
                        >
                            Cancel
                        </Button>
                    )}
                </div>
                <Divider className="divider" type="vertical" />
                <div>
                    <Title level={4}>Vehicles</Title>
                    <div className="list">
                        {
                            vehicles?.length || action === 'createVehicle' ?
                                <ul className="listConfig">
                                    {
                                        vehicles?.map((child, i) => {
                                            const isClickable = action === 'renameVehicle' || action === 'assignRad' || action === 'removeRad';
                                            return <li
                                                className={isClickable ? 'configItem configItemHover' : `configItem`}
                                                onClick={() => {
                                                    if (isClickable) {
                                                        setSelectedVehicle(i)
                                                        setSelectedRadSerial(null)
                                                    }
                                                }}
                                                key={i}
                                            >
                                                {
                                                    selectedVehicle === i && action === 'renameVehicle' ?
                                                        <Input
                                                            style={{
                                                                width: 200,
                                                            }}
                                                            onChange={(e) => {
                                                                setNewVehicleName(e.target.value)
                                                            }}
                                                            value={newVehicleName}
                                                            autoFocus
                                                        /> :
                                                        selectedVehicle === i && action === 'assignRad' ?
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }} onClick={(e) => e.stopPropagation()}>
                                                                <span>{child.name}</span>
                                                                <Select
                                                                    style={{ width: 150 }}
                                                                    placeholder="Select RAD"
                                                                    size="small"
                                                                    value={selectedRadSerial}
                                                                    onChange={(val) => setSelectedRadSerial(val)}
                                                                    options={unassignedRads.map(r => ({
                                                                        value: r.serial_number,
                                                                        label: r.serial_number,
                                                                    }))}
                                                                />
                                                                <Button
                                                                    size="small"
                                                                    type="primary"
                                                                    disabled={!selectedRadSerial}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setSave({
                                                                            vehicle_id: vehicles[selectedVehicle].id,
                                                                            serial: selectedRadSerial,
                                                                        })
                                                                        setSelectedRadSerial(null)
                                                                    }}
                                                                >
                                                                    Save
                                                                </Button>
                                                                <Button
                                                                    size="small"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setSelectedVehicle(-1)
                                                                        setSelectedRadSerial(null)
                                                                    }}
                                                                >
                                                                    Cancel
                                                                </Button>
                                                            </div>
                                                        :
                                                        <>
                                                            {child.name}
                                                            {child.rad_serial ? (
                                                                <Tag color="blue" style={{ marginLeft: '10px' }}>
                                                                    {child.rad_serial}
                                                                </Tag>
                                                            ) : (
                                                                <Tag color="default" style={{ marginLeft: '10px' }}>
                                                                    No RAD
                                                                </Tag>
                                                            )}
                                                        </>
                                                }
                                            </li>
                                        })
                                    }
                                    {action === 'createVehicle' && (
                                        <li className="configItem" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <Input
                                                style={{ width: 150 }}
                                                placeholder="Vehicle name"
                                                size="small"
                                                value={createVehicleName}
                                                onChange={(e) => setCreateVehicleName(e.target.value)}
                                                autoFocus
                                            />
                                            <Button
                                                size="small"
                                                type="primary"
                                                disabled={!createVehicleName.trim()}
                                                onClick={() => {
                                                    setSave({ name: createVehicleName.trim() })
                                                    setCreateVehicleName('')
                                                }}
                                            >
                                                Save
                                            </Button>
                                            <Button
                                                size="small"
                                                onClick={() => {
                                                    setAction('')
                                                    setCreateVehicleName('')
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                        </li>
                                    )}
                                </ul> :
                                <p className="subgroupText">There are currently no available vehicles.</p>
                        }
                    </div>
                </div>
                <Divider className="divider" type="vertical" />
                {radDevicesPanel}
            </div>
        </div>
    )
}
